const initialState =
 {  
    loading: false, 
    error:false,
    message:"",
    marcas:[],
    secciones:[],
    nameMarca:"",
    nameUnidad:"",
    idMarca:0,
    idUnidad:0,
    codeMetrico:"",
    nameMetrico:"",
    descMetrico:"",
    data:[],
    dataTable:[],
    valMetrico:"",
    formatMetrico:"",
    hasData:0

 }

export default (state = initialState, action) => {
    switch (action.type) {
       case "LOADING_MAIN_METRIC":
            return { ...state,loading:action.payload,error:false,message:""};
       case "ERROR_MAIN_METRIC":
            return { ...state,loading:false,error:true,message:action.payload};
       case "READY_GLOBAL_DATA_MAIN_METRIC":
            return { ...state,loading:false,error:false,message:"",
                    marcas:action.payload.marcas,secciones:action.payload.secciones};
       case "ERROR_TOKEN_MAIN_METRIC":
            return { ...state,loading:false,error:true,message:action.payload};
        case "CHANGE_MARCA_MAIN_METRIC":
            return { ...state,nameMarca:action.payload.nameMarca,nameUnidad:action.payload.nameUnidad,
                    idMarca:action.payload.idMarca,idUnidad:action.payload.idUnidad};
        case "CHANGE_METRICO_MAIN_METRIC":
            return { ...state,codeMetrico:action.payload.codigo,
                        nameMetrico:action.payload.nombre,
                        descMetrico:action.payload.descripcion,
                        formatMetrico:action.payload.formato,
                        valMetrico:action.payload.valor,
                        hasData:action.payload.data};
        case "READY_MENU_MAIN_METRIC":
            return { ...state,loading:false,error:false,message:"",secciones:action.payload};
        case "READY_DATA_MAIN_METRIC":
             return { ...state,loading:false,error:false,message:"",data:action.payload};
         case "READY_DATA_TABLE_MAIN_METRIC":
             return { ...state,loading:false,error:false,message:"",dataTable:action.payload};
       default:
    }
    return state;
}
